import React, { useState, useEffect } from "react";
import { getIcon } from "@/lib/icons";

// Grid thumbnail with resilient image loading (retry + cache-bust) and a
// graceful CSS fallback if the artwork is missing.
export const LibraryCardImage = ({ card, className = "" }) => {
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  const Icon = getIcon(card.icon);

  useEffect(() => {
    setError(false);
    setRetry(0);
  }, [card.image]);

  const handleError = () => {
    if (retry < 2) setRetry((r) => r + 1);
    else setError(true);
  };

  if (!card.image || error) {
    return (
      <div
        className={`flex h-full w-full flex-col items-center justify-center gap-3 ${className}`}
        style={{ background: "radial-gradient(circle at 50% 35%, rgba(114,47,55,0.3) 0%, #10111d 70%)" }}
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-full border border-[#D9A441]/40 bg-[#0B0C15]/60">
          <Icon className="h-7 w-7 text-[#D9A441]" strokeWidth={1.4} />
        </span>
        <span className="px-3 text-center font-display text-sm text-[#F8F3E6]">
          {card.title || card.name}
        </span>
      </div>
    );
  }

  return (
    <img
      src={retry > 0 ? `${card.image}?r=${retry}` : card.image}
      alt={card.title || card.name}
      onError={handleError}
      loading="lazy"
      draggable={false}
      className={`h-full w-full object-cover ${className}`}
    />
  );
};
